import request from '@/api/request'

export function listGpsUser (data) {
  return request({
    url: 'webapi/gps/user/list',
    method: 'post',
    data: data
  })
}

export function listAllGpsUser () {
  return request({
    url: 'webapi/gps/user/listAll',
    method: 'get'
  })
}

export function createGpsUser (data) {
  return request({
    url: 'webapi/gps/user/create',
    method: 'post',
    data: data
  })
}

export function updateGpsUser (data) {
  return request({
    url: 'webapi/gps/user/update',
    method: 'post',
    data: data
  })
}

export function getGpsUser (userId) {
  return request({
    url: 'webapi/gps/user/getGpsUser/' + userId,
    method: 'get'
  })
}

export function deleteGpsUser (userId) {
  const data = {
    userId: userId
  }
  return request({
    url: 'webapi/gps/user/delete',
    method: 'post',
    data: data
  })
}

export function getGpsUserByUserName (userName) {
  const data = {
    userName: userName
  }
  return request({
    url: 'webapi/gps/user/getGpsUserByName',
    method: 'post',
    data: data
  })
}

